export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.14-0826.45",
  commitId: "5f9639f8c4168aadc9a533ce43c2266d04a8750e",
  commitTime: "2026-08-14T08:26:45.000Z",
});
